import config from './production'
import { isWeb } from '@volt-libs/foundation'

const conf = {
    ...config,
    urls: {
        ...config.urls,
        authUrl: 'https://edsmobileprod.ott.ooredoo.qa:33428',
    },
    authenticationType: 'iptv',
    authenticationTypeTv: ['iptv'],
    firebaseConfig: {
        enabled: true,
        apiKey: "AIzaSyAublz4zyvCaVrHBAM3ev_1IqYZEVhvdcM",
        authDomain: "ooredoo-tv---preprod---uat.firebaseapp.com",
        projectId: "ooredoo-tv---preprod---uat",
        storageBucket: "ooredoo-tv---preprod---uat.firebasestorage.app",
        messagingSenderId: "235197332923",
        appId: `${isWeb ? '1:235197332923:web:8a119d5bbe61272067989e' : '1:235197332923:web:83f7b7ca8adb22cc67989e'}`,
        measurementId: `${isWeb ? 'G-JY9GJ8J092' : 'G-9R5BS3FQPQ'}`
    },
    env: "preproduction",
    watermark: {
        enabled: true,
        strength: 70
    }
};

export default conf;